

// 
/* =====================================================
   Initial Checkbox – PDP (Sara Fitz Horizon)
   Handles toggle, validation, and cart property
===================================================== */

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('SfInitialToggle');
  const inputWrap = document.querySelector('.sf-initial-input-wrapper');
  const input = document.getElementById('SfInitialInput'); // initials text input
  const error = document.querySelector('.sf-initial-error');
  const variantPicker = document.querySelector('variant-picker');
  const form = document.querySelector('.shopify-product-form');

  if (!toggle || !form || !inputWrap || !input) return;

  /* ----------------------------
     HELPERS
  ----------------------------- */

  const getPropertyInput = () => {
    let propInput = form.querySelector(
      'input[name="properties[Initial]"]'
    );

    if (!propInput) {
      propInput = document.createElement('input');
      propInput.type = 'hidden';
      propInput.name = 'properties[Initial]';
      form.appendChild(propInput);
    }

    return propInput;
  };

  const clearProperty = () => {
    const propInput = form.querySelector(
      'input[name="properties[Initial]"]'
    );
    if (propInput) {
      propInput.value = '';
    }
  };

  /* ----------------------------
     INITIAL LOAD
  ----------------------------- */

  inputWrap.classList.remove('hidden');

  if (variantPicker) {
    const yesRadio = variantPicker.querySelector(
      'input[type="radio"][value="Yes"]'
    );

    if (yesRadio) {
      toggle.checked = yesRadio.checked;
      inputWrap.hidden = !toggle.checked;

      if (!toggle.checked) {
        clearProperty();
      }
    }
  }

  /* ----------------------------
     TOGGLE → VARIANT + PROPERTY
  ----------------------------- */

  toggle.addEventListener('change', () => {
    inputWrap.hidden = !toggle.checked;
    error.hidden = true;

    if (!toggle.checked) {
      input.value = '';
      clearProperty();
    } else {
      getPropertyInput().value = input.value.toUpperCase();
    }

    if (!variantPicker) return;

    const targetValue = toggle.checked ? 'Yes' : 'No';
    const targetRadio = variantPicker.querySelector(
      `input[type="radio"][value="${targetValue}"]`
    );

    if (!targetRadio || targetRadio.checked) return;

    targetRadio.checked = true;
    targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----------------------------
     VARIANT → TOGGLE + PROPERTY
  ----------------------------- */

  document.addEventListener('change', (event) => {
    if (
      !event.target.matches('variant-picker input[type="radio"]') ||
      (event.target.value !== 'Yes' && event.target.value !== 'No')
    ) {
      return;
    }

    toggle.checked = event.target.value === 'Yes';
    inputWrap.hidden = !toggle.checked;
    error.hidden = true;

    if (!toggle.checked) {
      input.value = '';
      clearProperty();
    } else {
      getPropertyInput().value = input.value.toUpperCase();
    }
  });

  /* ----------------------------
     INITIAL INPUT → PROPERTY
  ----------------------------- */

  input.addEventListener('input', () => {
    if (!toggle.checked) return;
    getPropertyInput().value = input.value.toUpperCase();
  });
});
